import { useDipsResource, useDipsResources } from '../'

/** Sentinel id for optional singular lookups — never matches a real DIPS resource. */
export const NO_MATCH_DIPS_RESOURCE_ID = -1

/** Singular lookup by id; pass null/undefined to get undefined (uses sentinel id). */
export function useDipsResourceById(dipsResourceId: number | null | undefined) {
    return useDipsResource({ where: { id: dipsResourceId ?? NO_MATCH_DIPS_RESOURCE_ID } })
}

export function useMainSurgeonDipsResources() {
    return useDipsResources({
        where: { resourceTypeEnum: 'MainSurgeon' },
    })
}

export function useOperatingTheaterDipsResources() {
    return useDipsResources({
        where: { resourceTypeEnum: 'OperatingTheater' },
    })
}
